export default "__VITE_ASSET__0b590ce8__"